import { graphql, useMutation } from "react-relay";
import { useWorkspaceTodoEditAddFileMutation } from "./__generated__/useWorkspaceTodoEditAddFileMutation.graphql";

export function useWorkspaceTodoEditRemoveFile() {
  const [removeFiles] = useMutation<useWorkspaceTodoEditAddFileMutation>(
    graphql`
      mutation useWorkspaceTodoEditRemoveFileMutation(
        $todoWorkspaceId: ID!
        $fileIds: [ID!]!
      ) {
        todoWorkspace(id: $todoWorkspaceId) {
          removeFiles(fileIds: $fileIds) {
            id
            ...WorkspaceTodoEditMainEditedInfo_Todo
            descriptionFiles {
              id
            }
          }
        }
      }
    `
  );

  return (todoWorkspaceId: string, fileIds: string[]) => {
    removeFiles({
      variables: {
        todoWorkspaceId,
        fileIds,
      },
    });
  };
}
